import dateformat from 'dateformat';

export default function format_dateObj({ keyName, value }) {
    const obj = {};
    const dateValue = new Date(value);
    obj[keyName + 'ForBusQuery'] = dateformat(dateValue, 'yyyymmdd');
    obj[keyName + 'ForInput'] = dateformat(dateValue, 'ddd, d mmm');
    obj[keyName + 'Raw'] = dateValue;
    obj[keyName + 'ForUpdateSearch'] = dateformat(dateValue, 'd mmm yy:ddd');
    return obj;
  }
  